import axios from "axios";
import { authActions, store } from "../store";
import CONFIG from "../config";
import Utils from "../utils";
import { decryptData } from "../utils/crypto";

const API_URL = CONFIG.api_url;

const api = axios.create({
  baseURL: API_URL|| "https://justforpoints-api.onrender.com/api/v1/",
  headers: {
    "Content-Type": CONFIG.IS_JSON ? "application/json" : "text/plain",
  },
});

api.interceptors.request.use((config) => {
  const state = store.getState();
  const token = state.auth?.value?.token;

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    // if (status === 401) {
    //   store.dispatch(authActions.logout());
    //   window.location.replace("/login");
    // }
    if (status === 503 && error.response?.data?.maintenance) {
      window.location.replace("/maintenance");
      return;
    }

    return Promise.reject(error);
  },
);

export default api;
